// Sends one activity event as one Firestore document in the stored form the
// rules check (firestore.rules isValidSecurityActivity). The server sets the
// receipt time; the expiry is computed on the synchronized clock because the
// rules compare it with the server time.
import firebase, { db, FieldValue } from 'utils/firebase';
import { serverNow } from './clock';
import { ACTIVITY_COLLECTION, encodeChanges, encodeTargets, RETENTION_DAYS } from './events';
import { Transport } from './outbox';

const RETENTION_MS = RETENTION_DAYS * 24 * 60 * 60 * 1000;

export const firestoreTransport: Transport = ({ eventId, clientTime, targets, changes, ...event }) =>
  db
    .collection(`restaurants/${event.restaurantId}/${ACTIVITY_COLLECTION}`)
    .doc(eventId)
    .set({
      schemaVersion: 1,
      ...event,
      // Lets the Activities screen query executed actions and PIN authorizations apart.
      isAuthorization: event.category === 'authorization',
      targets: encodeTargets(targets),
      changes: encodeChanges(changes),
      // The device's own clock, unconfirmed.
      clientTime: firebase.firestore.Timestamp.fromMillis(clientTime),
      receivedAt: FieldValue.serverTimestamp(),
      expiresAt: firebase.firestore.Timestamp.fromMillis(serverNow() + RETENTION_MS),
    });
